"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.TabList = exports.NavItem = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var NavItem = _styled.default.nav(function (_ref) {
  var colors = _ref.theme.colors,
      fullWidth = _ref.fullWidth;
  return {
    width: '100%',
    overflowX: 'scroll',
    scrollBehavior: 'smooth',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    },
    borderBottom: fullWidth ? "1px solid ".concat(colors.greymid) : 'none'
  };
});

exports.NavItem = NavItem;

var TabList = _styled.default.ul(function (_ref2) {
  var fullWidth = _ref2.fullWidth;
  return {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    justifyContent: fullWidth ? 'space-between' : 'center',
    width: fullWidth ? '100%' : 'auto',
    textAlign: fullWidth ? 'center' : 'left'
  };
});

exports.TabList = TabList;